export default __webpack_public_path__ + "static/media/logo.458fd3de.png";